import { createSelector } from 'reselect';
import { StateAll } from '../../models';
import { initialLoadingState, LoadingState } from './model';

const rootSelector = (state: StateAll) => state['common/loading'] || initialLoadingState;

export const isApiLoading = createSelector(rootSelector, (state: LoadingState) => state && state && state.length > 0);
